/* global jQuery ScrollMagic TweenMax */

import respResize from './respResize';
import topMenu from './topMenu.js';

var $ = jQuery;

$.fn.isOnScreen = function() {
    var win = $(window);

    var viewport = {
        top: win.scrollTop(),
        left: win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
};
/* global theme ScrollMagic */
window.theme = {
    x: -1, 
    isOverlay: 0,
    scrollController: null,
    topMenu: topMenu,
    respResize: respResize,
    asyncScripts: [
    ],
    init: function() {
        var me = this;
        me.loadAsyncScripts();

        respResize.init();
        
        me.scrollController = new ScrollMagic.Controller();
        $(document).trigger('scrollControllerInitialized');

        $('#page').append('<div class="loading-overlay"><div><div class="spinner"><i class="fa fa-spinner fa-spin"></i> ładowanie...</div></div></div>');
        
        $(window).on('scroll', function() {
            if ($(window).scrollTop() > 50)
                $('#top-nav').addClass('_scroll');
            else
                $('#top-nav').removeClass('_scroll');
        });
        topMenu.init();
        $(document).trigger('themeInitialized');
        $('.post-tile')
            .each( (i, el) => {
                var $el = $(el);
                new ScrollMagic.Scene({ offset: 80, 
                        triggerHook: 'onEnter', 
                        triggerElement: el, 
                        duration: $el.outerHeight() + 50 })
                    .setTween( TweenMax.staggerFromTo( $el.find('.th-outer, .content, .data, h4'), 100, 
                                { top: 80, opacity: 0 }, { top: 0, opacity: 1 }, 70 ) 
                            )
                    .addTo(me.scrollController);
            });
        $('.sedzia')
            .each( (i, el) => {
                var $el = $(el);
                new ScrollMagic.Scene({ offset: 80, 
                        triggerHook: 'onEnter', 
                        triggerElement: el })
                    .setTween( TweenMax.fromTo( $el, 1, 
                                { top: 110, opacity: 0 }, { top: 0, opacity: 1 } ) 
                            )
                    .addTo(me.scrollController);
            });
        $('.lista-sedziow h3')
            .each( (i, el) => {
                var $el = $(el);
                new ScrollMagic.Scene({ offset: 30, 
                        triggerHook: 'onEnter', 
                        triggerElement: el })
                    .setTween( TweenMax.fromTo( $el, 1, 
                                { top: 30, opacity: 0 }, { top: 0, opacity: 1 } ) 
                            )
                    .addTo(me.scrollController);
            });   
         $('.foto-wrapper')
            .each( (i, el) => {
                var $el = $(el);
                new ScrollMagic.Scene({ offset: 100, 
                        triggerHook: 'onEnter', 
                        triggerElement: el })
                    .setTween( TweenMax.staggerFromTo( $el.find('.gallery-item'), 0.6, 
                                { top: 200, opacity: 0 }, { top: 0, opacity: 1 }, 0.1 ) 
                            )
                    .addTo(me.scrollController);
            });           
            
        new ScrollMagic.Scene({ offset: 150, 
                    triggerHook: 'onEnter', 
                    triggerElement: '.lzps-partnerzy' 
                })
                .setTween( TweenMax.staggerFromTo( '.lzps-partnerzy li', 0.7, 
                                { left: '-50%', opacity: 0 }, { left: '0%', opacity: 1 }, -0.1 ) 
                        )
                .addTo(me.scrollController);
        
        $(document).on('changeMobile', theme.changeMobile);
        me.changeMobile();
    },
    
    showOverlay: function() {
        if ( !this.isOverlay ) 
            $('.loading-overlay').stop().fadeIn();
        $('.loading-overlay .spinner').css({'top': ($(window).scrollTop() + $(window).height() / 2)});
        this.isOverlay++;
    },
    
    hideOverlay: function() {
        this.isOverlay--;
        if ( this.isOverlay ) return;
        $('.loading-overlay').stop().fadeOut(200);  
    },

    hMenuToggle: () => {
        var $menu = $('#hm-menu-menu'), $li = $(this).parent();
        if ($li.hasClass('_open')) {
            $li.add($li.children('li')).removeClass('_open');
        } else {
            $menu.find('li._open').not($li.parents('li')).removeClass('_open');
            $li.addClass('_open');
        }
    },
    
    loadAsyncScripts: () => {
        var me = theme,
            n = function(o, c) {
            var n = document.createElement('script'); n.type = 'text/javascript';
            n.async = true; n.src = o;
            c = c || function() { theme.scriptAsyncLoaded(o); };
            n.addEventListener ? n.onload = c
            : n.onreadystatechange = function() { /loaded|complete/.test(n.readyState) && c(); };
            return n;
        };
        if ( me.asyncScripts.length ) {
            while (me.asyncScripts[++me.x]) 
                document.getElementsByTagName("head")[0].appendChild(n(me.asyncScripts[me.x]));
        } else 
            $(document).trigger('allAsyncScriptsLoaded');
    },
    
    scriptAsyncLoaded: function(s) {
        var me = theme;
        --me.x;
        $(document).trigger({type: 'asyncScriptLoaded', script: s.split('/').pop()});
        if (me.x) 
            return;
        $(document).trigger('allAsyncScriptsLoaded');
    },
    
    onLoad: () => {
        var me = theme;
        me.loaded = true;
        $('body').addClass('loaded');
    },

    changeMobile: () => {
        if ( respResize.isMobile() ) {
            if ( theme.logoScene ) {
                theme.logoScene.destroy(true);
                theme.logoScene = null;
            }
        } else {
            theme.logoScene = new ScrollMagic.Scene({  
                    reverse: true,
                    offset: $('#header').height()
                })
                .setClassToggle("#tlogo", 'pined')
                .setPin("#tlogo")
                .addTo(theme.scrollController);
        }
    }
};
